module.exports = __webpack_public_path__ + "img/9n.ea131df1.png";